import { useConfigProvider } from '@/lib/context';
import Breadcrumbs from './Breadcrumbs';
import './index.less';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { message } from 'antd';
import { forwardRef, useRef } from 'react';
import { useHistoryList } from '@/lib/context/HistoryListProvider';

interface SourcingBreadcrumbProps {
  isMobileFromServer?: boolean;
  usedLocation: 'FDL_and_PDL' | 'FDP' | 'PDP'; // it means where this component is used.
}
const SourcingBreadcrumbs = forwardRef(({ usedLocation, isMobileFromServer }: SourcingBreadcrumbProps, ref) => {
  const { isMobile: isMobileFromClient } = useConfigProvider();
  const { sourcingBreadcrumbs } = useHistoryList();
  const breadcrumbsRef = useRef(null);
  const isMobile = isMobileFromServer ?? isMobileFromClient;

  const ShareItemButton = () => (
    <div className="share-item">
      <CopyToClipboard
        text={window.location}
        onCopy={() => {
          message.success('The link to this product has been copied to your clipboard.');
        }}
      >
        <div className="inner">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img className="upload-file-icon" src="/images/sourcing/share-black.svg" width={16} height={16} alt="share" />
          <span>Share</span>
        </div>
      </CopyToClipboard>
    </div>
  );

  if (!sourcingBreadcrumbs || sourcingBreadcrumbs?.length <= 0) return null;

  return (
    <div className="sourcing-breadcrumbs-box">
      <Breadcrumbs ref={breadcrumbsRef} usedLocation={usedLocation} />
      <div className="right-box">{!isMobile && <ShareItemButton />}</div>
    </div>
  );
});

export default SourcingBreadcrumbs;
